import { useState } from "react";
import Modal from "react-modal";
import "./index.css";

type HotelOption = {
  pluginspaceId: number;
  name: string;
  subdomain: string;
  image?: string;
  description?: string;
  paymentIntegrated?: boolean;
};

type ModalSelectHotelProps = {
  isOpen: boolean;
  hotels: HotelOption[];
  onSelect: (hotel: HotelOption) => void;
  onClose?: () => void;
};

export function ModalSelectHotel({
  isOpen,
  hotels,
  onSelect,
  onClose,
}: ModalSelectHotelProps) {
  const [selectedHotel, setSelectedHotel] = useState<HotelOption | null>(null);

  const handleConfirm = () => {
    if (selectedHotel) {
      onSelect(selectedHotel);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      className="modal-select-hotel"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-select-hotel-content">
        <div className="modal-select-hotel-header">
          <svg
            onClick={onClose}
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
              fill="#636363"
            />
          </svg>
          <h2>Selecione o Hotel</h2>
          <p>Escolha o hotel de origem para continuar</p>
        </div>

        <div className="modal-select-hotel-list">
          {hotels.map((hotel) => (
            <div
              key={hotel.pluginspaceId}
              className={`hotel-option ${
                selectedHotel?.pluginspaceId === hotel.pluginspaceId
                  ? "selected"
                  : ""
              }`}
              onClick={() => setSelectedHotel(hotel)}
            >
              <div className="hotel-option-content">
                <h3>{hotel.name}</h3>
              </div>
              <div className="hotel-option-check">
                {selectedHotel?.pluginspaceId === hotel.pluginspaceId && (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="modal-select-hotel-actions">
          <button
            className="modal-select-hotel-btn-confirm"
            onClick={handleConfirm}
            disabled={!selectedHotel}
          >
            Confirmar
          </button>
        </div>
      </div>
    </Modal>
  );
}
